import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const AppLogo = styled(Box)({
    display: 'inline-block',
    marginBottom: '45px',
});

export const AppLogoImg = styled('img')({
    maxWidth: '100%',
});

export const DescriptionBox = styled(Box)({
    marginBottom: '30px',
});
